import { NavLink } from 'react-router-dom';
import { useDashboardData } from '../hooks/useDashboardData';
import './ProvisioningTabs.css';

export function ProvisioningTabs() {
  const { isSuperAdmin } = useDashboardData();
  return (
    <nav className="provisioning-tabs" aria-label="Provisioning sections">
      <NavLink to="/dashboard/provision" end>Factory provision</NavLink>
      {isSuperAdmin && <NavLink to="/dashboard/provision/devices">Device lifecycle</NavLink>}
    </nav>
  );
}
